export default "__VITE_ASSET__39bb270c__"